import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="page-header">
        <h1>About Us</h1>
        <div className="section-divider"></div>
      </div>

      {/* Our Story */}
      <section className="about-page__story section">
        <div className="container">
          <h2 className="section-title">Our Story</h2>
          <div className="section-divider"></div>
          <div className="about-page__story-content">
            <p>
              Founded in 2010 by Chef Antonio Rossi and restaurateur Maria Lopez,
              Cafe Fausse blends traditional Italian flavors with modern culinary
              innovation. What began as a shared dream between two passionate food
              lovers has grown into one of Washington, DC's most celebrated dining
              destinations.
            </p>
            <p>
              Our mission is to provide an unforgettable dining experience that
              reflects both quality and creativity. Every dish that leaves our kitchen
              tells a story — of heritage, of craftsmanship, and of an unwavering
              commitment to excellence.
            </p>
          </div>
        </div>
      </section>

      {/* Founders */}
      <section className="about-page__founders section">
        <div className="container">
          <h2 className="section-title">Meet the Founders</h2>
          <div className="section-divider"></div>
          <div className="about-page__founders-grid">
            <div className="about-page__founder">
              <div className="about-page__founder-img">
                <img src="/images/AntonioRossi.png" alt="Chef Antonio Rossi" />
              </div>
              <h3>Chef Antonio Rossi</h3>
              <p className="about-page__founder-title">Executive Chef & Co-Founder</p>
              <p className="about-page__founder-bio">
                With over 25 years of culinary experience across Italy and the United
                States, Chef Antonio brings his passion for traditional Italian cooking
                to every plate. Trained at the Culinary Institute of Bologna, he is
                dedicated to sourcing the finest locally grown ingredients and
                transforming them into extraordinary dining experiences.
              </p>
            </div>

            <div className="about-page__founder">
              <div className="about-page__founder-img">
                <img src="/images/maria-lopez.svg" alt="Maria Lopez" />
              </div>
              <h3>Maria Lopez</h3>
              <p className="about-page__founder-title">Restaurateur & Co-Founder</p>
              <p className="about-page__founder-bio">
                Maria's vision for Cafe Fausse was born from years of experience in
                the hospitality industry and a deep love for creating welcoming spaces.
                Her keen eye for design and unwavering commitment to exceptional service
                have made Cafe Fausse a destination where every guest feels like family.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="about-page__mission section">
        <div className="container">
          <blockquote className="about-page__quote">
            <p>
              "We believe that great food has the power to bring people together.
              At Cafe Fausse, every meal is a celebration of flavor, tradition,
              and the joy of shared moments."
            </p>
            <cite>— Chef Antonio Rossi & Maria Lopez</cite>
          </blockquote>
        </div>
      </section>

      {/* Commitment */}
      <section className="about-page__commitment section">
        <div className="container">
          <h2 className="section-title">Our Commitment</h2>
          <div className="section-divider"></div>
          <div className="about-page__commitment-grid">
            <div className="about-page__commitment-card">
              <h3>Locally Sourced</h3>
              <p>
                We partner with local farms and producers to bring you the freshest,
                highest-quality ingredients every season.
              </p>
            </div>
            <div className="about-page__commitment-card">
              <h3>Culinary Excellence</h3>
              <p>
                Our kitchen team combines time-honored techniques with modern
                innovation to create dishes that delight and inspire.
              </p>
            </div>
            <div className="about-page__commitment-card">
              <h3>Unforgettable Dining</h3>
              <p>
                From the moment you walk in, every detail is crafted to ensure
                your experience is nothing short of extraordinary.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
